import { supabase } from '@/lib/supabase';

interface AddPointsParams {
  userId: string;
  amount: number;
  source: string;
  sourceId: string;
  description: string;
}

interface PointsResponse {
  transaction: any;
  newTotalPoints: number;
}

export const addPoints = async ({
  userId,
  amount,
  source,
  sourceId,
  description
}: AddPointsParams): Promise<PointsResponse> => {
  try {
    // Registramos la sesión del juego
    const { data: sessionData, error: sessionError } = await supabase
      .from('game_session_results')
      .insert({
        user_id: userId,
        game_id: sourceId,
        points_earned: amount || 0, // Asegurar que nunca sea null
        session_duration: 0,
        difficulty_level: 'basic'
      })
      .select()
      .single();

    if (sessionError) throw sessionError;

    // Luego actualizamos el progreso del juego
    const { data: progressData, error: progressError } = await supabase
      .from('game_progress')
      .upsert({
        user_id: userId,
        game_id: sourceId,
        total_plays: 1,
        high_score: amount || 0, // Asegurar que nunca sea null
        last_played_at: new Date().toISOString(),
      }, {
        onConflict: 'user_id,game_id',
      })
      .select();

    if (progressError) throw progressError;

    return { 
      transaction: sessionData, 
      newTotalPoints: amount || 0 
    };
  } catch (error) {
    console.error('Error adding points:', error);
    throw error;
  }
};
